import { useTranslation } from 'react-i18next';

export function ProductionDeclarationMaterialAdditionalFilesTooltipContent() {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });

  return (
    <>
      <p className='font-semibold text-declaration-foreground text-sm'>
        {t('materialCommodityOrigins.cards.additionalFiles.tooltip.title')}
      </p>
      <ul className='list-disc space-y-1 pl-5'>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.readableScans',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.uploadSequence',
          )}
        </li>
      </ul>
      <p>
        {t(
          'materialCommodityOrigins.cards.additionalFiles.tooltip.sequenceExample',
        )}
      </p>
      <p>
        {t('materialCommodityOrigins.cards.additionalFiles.tooltip.eudrIntro')}
      </p>
      <ol className='list-decimal space-y-1 pl-5'>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.geolocation',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.production',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.legal',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.traceability',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.thirdParty',
          )}
        </li>
        <li>
          {t(
            'materialCommodityOrigins.cards.additionalFiles.tooltip.evidenceTypes.alternative',
          )}
        </li>
      </ol>
    </>
  );
}
